<template>
	<div class="settings-container">
		<div class="settings-content">
			<!-- 主要内容区域 -->
			<div class="main-content">
				<!-- 左侧标签页 -->
				<div class="tabs-section">
					<el-tabs v-model="activeTab" class="settings-tabs">
						<el-tab-pane name="process">
							<template #label>
								<span class="tab-label">
									<i class="el-icon-s-claim"></i>
									理赔流程
								</span>
							</template>
							<div class="tab-content">
								<div class="tab-header">
									<h3>理赔流程设置</h3>
									<div class="tab-actions">
										<el-button type="primary" size="small" @click="addProcessStep" class="add-btn">
											<i class="el-icon-plus"></i> 添加步骤
										</el-button>
										<!-- <el-button type="success" size="small" @click="generateDefaultProcess" class="default-btn">
											<i class="el-icon-refresh"></i> 生成默认
										</el-button> -->
									</div>
								</div>
								<div class="process-steps-settings">
									<draggable v-model="processSteps" handle=".drag-handle">
										<div v-for="(step, index) in processSteps" :key="index" class="step-setting">
											<div class="step-header">
												<i class="el-icon-rank drag-handle"></i>
												<span class="step-number">步骤 {{ index + 1 }}</span>
												<el-button type="danger" size="mini" @click="removeProcessStep(index)"
													class="delete-btn">
													<i class="el-icon-delete"></i> 删除
												</el-button>
											</div>
											<div class="step-content">
												<el-input v-model="step.title" placeholder="步骤标题" class="step-title-input"></el-input>
												<el-input v-model="step.description" type="textarea" :rows="2" placeholder="步骤描述"
													class="step-desc-input"></el-input>
											</div>
										</div>
									</draggable>
								</div>
							</div>
						</el-tab-pane>

						<el-tab-pane name="materials">
							<template #label>
								<span class="tab-label">
									<i class="el-icon-s-management"></i>
									理赔材料
								</span>
							</template>
							<div class="tab-content">
								<div class="tab-header">
									<h3>理赔材料设置</h3>
									<div class="tab-actions">
										<el-button type="primary" size="small" @click="addMaterialItem" class="add-btn">
											<i class="el-icon-plus"></i> 添加材料
										</el-button>
										<!-- <el-button type="success" size="small" @click="generateDefaultMaterials" class="default-btn">
											<i class="el-icon-refresh"></i> 生成默认
										</el-button> -->
									</div>
								</div>
								<div class="materials-settings">
									<draggable v-model="materialItems" handle=".drag-handle">
										<div v-for="(item, index) in materialItems" :key="index" class="material-setting">
											<div class="material-header">
												<i class="el-icon-rank drag-handle"></i>
												<span class="material-title">材料项 {{ index + 1 }}</span>
												<el-button type="danger" size="mini" @click="removeMaterialItem(index)" class="delete-btn">
													<i class="el-icon-delete"></i> 删除
												</el-button>
											</div>
											<div class="material-content">
												<div class="icon-selector">
													<span class="label">图标:</span>
													<el-select v-model="item.icon" placeholder="选择图标" size="small">
														<el-option v-for="icon in iconOptions" :key="icon.value" :label="icon.label"
															:value="icon.value">
															<i :class="icon.value"></i> {{ icon.label }}
														</el-option>
													</el-select>
												</div>
												<el-input v-model="item.title" placeholder="材料标题" class="material-title-input"></el-input>
												<el-input v-model="item.description" type="textarea" :rows="2" placeholder="材料描述"
													class="material-desc-input"></el-input>
											</div>
										</div>
									</draggable>
								</div>
							</div>
						</el-tab-pane>

						<el-tab-pane name="tips">
							<template #label>
								<span class="tab-label">
									<i class="el-icon-s-opportunity"></i>
									理赔小贴士
								</span>
							</template>
							<div class="tab-content">
								<div class="tab-header">
									<h3>理赔小贴士设置</h3>
									<div class="tab-actions">
										<el-button type="primary" size="small" @click="addTipItem" class="add-btn">
											<i class="el-icon-plus"></i> 添加贴士
										</el-button>
										<!-- <el-button type="success" size="small" @click="generateDefaultTips" class="default-btn">
											<i class="el-icon-refresh"></i> 生成默认
										</el-button> -->
									</div>
								</div>
								<div class="tips-settings">
									<draggable v-model="tipItems" handle=".drag-handle">
										<div v-for="(tip, index) in tipItems" :key="index" class="tip-setting">
											<div class="tip-header">
												<i class="el-icon-rank drag-handle"></i>
												<span class="tip-title">贴士 {{ index + 1 }}</span>
												<el-button type="danger" size="mini" @click="removeTipItem(index)" class="delete-btn">
													<i class="el-icon-delete"></i> 删除
												</el-button>
											</div>
											<div class="tip-content">
												<el-input v-model="tip.title" placeholder="贴士标题" class="tip-title-input"></el-input>
												<el-input v-model="tip.content" type="textarea" :rows="2" placeholder="贴士内容"
													class="tip-content-input"></el-input>
											</div>
										</div>
									</draggable>
								</div>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>

				<!-- 右侧操作按钮 -->
				<div class="action-section">
					<div class="action-card">
						<h3><i class="el-icon-s-operation"></i> 操作</h3>
						<div class="action-buttons">
							<el-button type="primary" @click="saveSettings" size="large" class="save-btn">
								<i class="el-icon-check"></i> 保存设置
							</el-button>
							<!-- <el-button type="warning" @click="resetToDefault" size="large" class="reset-btn">
								<i class="el-icon-refresh-left"></i> 重置默认
							</el-button> -->
						</div>
						<div class="action-tips">
							<p><i class="el-icon-info"></i> 提示：拖拽可调整顺序</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'

	export default {
		name: 'ClaimsGuideSettings',
		components: {
			draggable
		},
		data() {
			return {
				// 当前激活的标签页
				activeTab: 'process',
				// 理赔流程数据
				processSteps: [],
				// 理赔材料数据
				materialItems: [],
				// 理赔小贴士数据
				tipItems: [],
				// 图标选项
				iconOptions: [{
						value: 'el-icon-s-custom',
						label: '用户'
					},
					{
						value: 'el-icon-s-management',
						label: '管理'
					},
					{
						value: 'el-icon-warning',
						label: '警告'
					},
					{
						value: 'el-icon-s-order',
						label: '订单'
					},
					{
						value: 'el-icon-s-finance',
						label: '财务'
					},
					{
						value: 'el-icon-s-claim',
						label: '保险'
					},
					{
						value: 'el-icon-s-opportunity',
						label: '机会'
					},
					{
						value: 'el-icon-s-help',
						label: '帮助'
					},
					{
						value: 'el-icon-truck',
						label: '运输'
					},
					{
						value: 'el-icon-phone',
						label: '电话'
					}
				]
			}
		},
		mounted() {
			this.getPageData();
		},
		methods: {
			// 添加流程步骤
			addProcessStep() {
				this.processSteps.push({
					title: '新步骤',
					description: '请填写步骤描述'
				})
			},

			// 删除流程步骤
			removeProcessStep(index) {
				this.processSteps.splice(index, 1)
			},

			// 添加材料项
			addMaterialItem() {
				this.materialItems.push({
					icon: 'el-icon-s-custom',
					title: '新材料项',
					description: '请填写材料描述'
				})
			},

			// 删除材料项
			removeMaterialItem(index) {
				this.materialItems.splice(index, 1)
			},

			// 添加贴士项
			addTipItem() {
				this.tipItems.push({
					title: '新贴士标题',
					content: '请填写贴士内容'
				})
			},

			// 删除贴士项
			removeTipItem(index) {
				this.tipItems.splice(index, 1)
			},

			// 生成默认理赔流程
			generateDefaultProcess() {
				this.$confirm('此操作将覆盖当前理赔流程设置，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.processSteps = [
						{
							title: '报案通知',
							description: '发生保险事故后，请第一时间拨打我们的24小时客服热线400-123-4567报案，或通过在线渠道提交报案信息。'
						},
						{
							title: '准备材料',
							description: '根据客服指引准备理赔所需材料，包括身份证明、医疗单据、事故证明等，确保材料真实完整。'
						},
						{
							title: '提交申请',
							description: '通过官方网站、APP或邮寄方式提交理赔申请及相关材料，我们将在收到材料后1个工作日内确认受理。'
						},
						{
							title: '审核处理',
							description: '我们的专业团队将对您的理赔申请进行审核，如有需要可能会与您联系补充材料，一般案件5-7个工作日内完成审核。'
						},
						{
							title: '理赔支付',
							description: '审核通过后，理赔款项将在3个工作日内支付到您指定的银行账户，并发送通知短信。'
						}
					];
					this.$message({
						type: 'success',
						message: '默认理赔流程已生成'
					});
				}).catch(() => {
					// 用户取消操作
				});
			},

			// 生成默认理赔材料
			generateDefaultMaterials() {
				this.$confirm('此操作将覆盖当前理赔材料设置，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.materialItems = [
						{
							icon: 'el-icon-s-custom',
							title: '身份证明',
							description: '投保人、被保险人及受益人的有效身份证件'
						},
						{
							icon: 'el-icon-s-management',
							title: '医疗单据',
							description: '病历、诊断证明、医疗费用原始凭证等'
						},
						{
							icon: 'el-icon-warning',
							title: '事故证明',
							description: '警方报告、事故鉴定书等相关证明文件'
						},
						{
							icon: 'el-icon-warning',
							title: '费用凭证',
							description: '交通费、住宿费等相关费用的原始票据'
						},
						{
							icon: 'el-icon-s-order',
							title: '保单凭证',
							description: '电子或纸质保单、投保确认书等'
						},
						{
							icon: 'el-icon-s-finance',
							title: '银行账户',
							description: '受益人有效银行账户信息'
						}
					];
					this.$message({
						type: 'success',
						message: '默认理赔材料已生成'
					});
				}).catch(() => {
					// 用户取消操作
				});
			},

			// 生成默认理赔小贴士
			generateDefaultTips() {
				this.$confirm('此操作将覆盖当前理赔小贴士设置，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.tipItems = [
						{
							title: '及时报案',
							content: '出险后请第一时间报案，保留现场证据'
						},
						{
							title: '保管票据',
							content: '妥善保管所有原始票据和证明文件'
						},
						{
							title: '如实填写',
							content: '如实填写理赔申请，避免因信息不实影响理赔'
						},
						{
							title: '关注进度',
							content: '关注理赔进度，及时补充所需材料'
						},
						{
							title: '及时沟通',
							content: '如有疑问，及时联系客服获取专业指导'
						}
					];
					this.$message({
						type: 'success',
						message: '默认理赔小贴士已生成'
					});
				}).catch(() => {
					// 用户取消操作
				});
			},

			// 重置为默认数据
			resetToDefault() {
				this.$confirm('此操作将重置所有设置为默认内容，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.generateDefaultProcess();
					this.generateDefaultMaterials();
					this.generateDefaultTips();
					this.$message({
						type: 'success',
						message: '已重置为默认设置'
					});
				}).catch(() => {
					// 用户取消操作
				});
			},
			
			getPageData(){
				this.$get('app-page-design/4').then(res=>{
					const data		   = res.data.content;
					this.processSteps  = data.processSteps || [];
					this.materialItems = data.materialItems || [];
					this.tipItems 	   = data.tipItems || [];
				}).catch(err=>{
					this.$message({
						message: err,
						type: 'warning'
					})
				});
			},

			// 保存设置
			saveSettings() {
				const data = {
					processSteps: this.processSteps,
					materialItems: this.materialItems,
					tipItems: this.tipItems
				};
				this.$put('app-page-design/4', {
					content: JSON.stringify(data)
				}).then(res=>{
					this.$message({
						message: '设置保存成功',
						type: 'success'
					})
				}).catch(err=>{
					this.$message({
						message: err,
						type: 'warning'
					})
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.settings-container {
		padding: 20px;
		background-color: #f5f7fa;
		height: 100%;
		overflow-y: auto;
		box-sizing: border-box;
	}

	.settings-content {
		max-width: 1200px;
		margin: 0 auto;
		min-height: min-content;
	}

	// 主要内容区域
	.main-content {
		display: grid;
		grid-template-columns: 1fr 320px;
		gap: 24px;
		align-items: start;
	}

	// 标签页区域
	.tabs-section {
		background: white;
		border-radius: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		overflow: hidden;
	}

	.settings-tabs {
		::v-deep .el-tabs__header {
			background: #f8f9fa;
			margin: 0;
			padding: 0 24px;
			border-bottom: 1px solid #e8e8e8;
		}

		::v-deep .el-tabs__nav-wrap {
			&::after {
				display: none;
			}
		}

		::v-deep .el-tabs__item {
			font-weight: 500;
			padding: 0 32px;
			height: 60px;
			line-height: 60px;
			font-size: 15px;
			color: #666;
			transition: all 0.3s ease;
			position: relative;

			&.is-active {
				color: #5B8CFF;
			}

			&:hover {
				color: #5B8CFF;
			}
		}

		.tab-label {
			display: flex;
			align-items: center;
			gap: 8px;
			font-weight: 500;
		}
	}

	.tab-content {
		padding: 24px;
		min-height: 500px;
	}

	.tab-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 24px;
		padding-bottom: 16px;
		border-bottom: 1px solid #f0f0f0;

		h3 {
			margin: 0;
			color: #303133;
			font-size: 18px;
			font-weight: 600;
		}

		.tab-actions {
			display: flex;
			gap: 10px;
		}
	}

	.add-btn {
		background: #5B8CFF;
		border-color: #5B8CFF;
		border-radius: 6px;
		font-weight: 500;
		
		&:hover {
			background: #4a7df5;
			border-color: #4a7df5;
		}
	}

	.default-btn {
		background: #67C23A;
		border-color: #67C23A;
		border-radius: 6px;
		font-weight: 500;
		
		&:hover {
			background: #5daf34;
			border-color: #5daf34;
		}
	}

	// 操作按钮区域
	.action-section {
		position: sticky;
		top: 0;
	}

	.action-card {
		background: white;
		border-radius: 12px;
		padding: 24px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		text-align: center;

		h3 {
			margin: 0 0 20px 0;
			color: #303133;
			font-size: 18px;
			font-weight: 600;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 8px;
		}
	}

	.action-buttons {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin-bottom: 20px;
	}

	.save-btn {
		background: #5B8CFF;
		border-color: #5B8CFF;
		border-radius: 8px;
		height: 44px;
		font-weight: 500;
		box-shadow: 0 4px 12px rgba(91, 140, 255, 0.3);
		transition: all 0.3s ease;

		&:hover {
			background: #4a7df5;
			border-color: #4a7df5;
			transform: translateY(-2px);
			box-shadow: 0 6px 16px rgba(91, 140, 255, 0.4);
		}
	}

	.reset-btn {
		background: #E6A23C;
		border-color: #E6A23C;
		border-radius: 8px;
		height: 44px;
		font-weight: 500;
		transition: all 0.3s ease;

		&:hover {
			background: #d9922b;
			border-color: #d9922b;
			transform: translateY(-2px);
		}
	}

	.action-tips {
		padding: 16px;
		background: #f8f9fa;
		border-radius: 8px;
		border-left: 4px solid #5B8CFF;

		p {
			margin: 0;
			color: #666;
			font-size: 14px;
			display: flex;
			align-items: center;
			gap: 8px;
		}
	}

	// 设置项样式优化
	.process-steps-settings,
	.materials-settings,
	.tips-settings {
		.step-setting,
		.material-setting,
		.tip-setting {
			border: 1px solid #e8e8e8;
			border-radius: 8px;
			margin-bottom: 16px;
			overflow: hidden;
			transition: all 0.3s ease;
			background: white;

			&:hover {
				border-color: #5B8CFF;
				box-shadow: 0 2px 8px rgba(91, 140, 255, 0.1);
			}

			.step-header,
			.material-header,
			.tip-header {
				display: flex;
				align-items: center;
				padding: 12px 16px;
				background: #f8f9fa;
				border-bottom: 1px solid #e8e8e8;

				.drag-handle {
					margin-right: 12px;
					color: #909399;
					cursor: move;
					font-size: 16px;
				}

				.step-number,
				.material-title,
				.tip-title {
					flex: 1;
					font-weight: 500;
					color: #303133;
				}
			}

			.step-content,
			.material-content,
			.tip-content {
				padding: 16px;

				.step-title-input,
				.material-title-input,
				.tip-title-input {
					margin-bottom: 12px;
				}
			}
		}
	}

	.icon-selector {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		padding: 8px;
		background: #f8f9fa;
		border-radius: 6px;

		.label {
			margin-right: 12px;
			color: #606266;
			font-weight: 500;
			min-width: 40px;
		}
	}

	.delete-btn {
		margin-left: auto;
		border-radius: 4px;
	}

	// 响应式设计
	@media (max-width: 1024px) {
		.main-content {
			grid-template-columns: 1fr;
			gap: 20px;
		}

		.action-section {
			position: static;
		}

		.settings-tabs {
			::v-deep .el-tabs__item {
				padding: 0 20px;
			}
		}
	}

	@media (max-width: 768px) {
		.settings-container {
			padding: 12px;
		}

		.tab-content {
			padding: 16px;
		}

		.tab-header {
			flex-direction: column;
			gap: 12px;
			align-items: stretch;

			h3 {
				text-align: center;
			}

			.tab-actions {
				justify-content: center;
			}
		}

		.action-buttons {
			gap: 8px;
		}

		.save-btn,
		.reset-btn {
			height: 40px;
		}
	}
</style>